import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2025 Mathurakshi Mahendrarajah. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
